import {Injectable} from '@angular/core'
import {HttpService} from './_.http-mock'
import {Observable} from 'rxjs'
import {SectionModel} from '../model/section.model'


@Injectable()
export class SectionHttp {

  constructor(protected http: HttpService) {
  }

  add(section: SectionModel): Observable<SectionModel> {
    return this.http.put(`section`, section)
  }

  update(section: SectionModel): Observable<SectionModel> {
    return this.http.post(`section/${section.id}`, section)
  }

  remove(sectionId: string): Observable<any> {
    return this.http.delete(`section/${sectionId}`)
  }
}
